<script>
    import { onMount } from 'svelte';
    import OperatorDataProvider from '../../scripts/operatordataprovider';

    export let value;
    export let name;

    let operators = [];

    onMount(async () => {
        operators = await OperatorDataProvider.loadOperators();

        operators.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }

            if (a.name > b.name) {
                return 1;
            }

            return 0;
        });
    });
</script>

<select {name} bind:value class="form-control-sm">
    <option value="">Välj</option>
    {#each operators as operator}
        <option value={operator._id}>{operator.name}</option>
    {/each}
</select>

<style>
    .form-control-sm {
        width: 100%;
        font-size: 12px;
    }
</style>